import { BinGroupListAction } from "./action";
import { BinGroupInterface, binGroupListState } from "./state";

export function BinGroupReducer(
  state: BinGroupInterface = binGroupListState,
  action: BinGroupListAction
): BinGroupInterface {

    switch (action.type) {
        case "@@InitBinGroupListState/initGroupNameTcAction":
            const group_name_tc = action.group_name_tc;
            return {
                ...state,
                newBinGroup: {
                    ...state.newBinGroup,
                    group_name_tc: group_name_tc,
                },
            };
        case '@@InitBinGroupListState/initGroupNameEnAction':
               const group_name_en = action.group_name_en;
            return {
                ...state,
                newBinGroup: {
                    ...state.newBinGroup,
                    group_name_en: group_name_en,
                },
            };



              case '@@InitBinGroupListState/changeSelectedBinGroupSequenceAction':
      return {
        ...state,
        selectedBinInBinGroup: state.selectedBinInBinGroup!.map((bin) => {
          if (bin.bin_id == action.bin_id) {
            return {
              ...bin,
              bin_group_sequence: action.bin_group_sequence,
            };
          }

          return bin;
        }),
      };

        case '@@InitBinGroupListState/initSelectedBinInBinGroupAction':
            return {
        ...state,
        selectedBinInBinGroup: action.selectedBinInBinGroup,
        originalBinGroup:action.selectedBinInBinGroup
      };

      case '@@InitBinGroupListState/changeSelectedBinInBinGroupAction':

          return {
        ...state,
        selectedBinInBinGroup: state.selectedBinInBinGroup!.map((bin) => {
          if (bin.bin_id == action.original_bin_id) {
            return {
              ...bin,
              bin_id:action.newLocation!.bin_id,
              code:action.newLocation!.code,
              label:action.newLocation!.label,
              location_cn:action.newLocation!.location_cn,
              toilet_number:action.newLocation!.toilet_number,
              value:action.newLocation!.value
            };
          }

          return bin;
        }),
      };

      case '@@InitBinGroupListState/changeBinGroupIsActiveAction':
      return {
        ...state,
        newBinGroup: {
          ...state.newBinGroup,
          is_active: action.is_active=='1'?1:0,
        },
      };
      
   case '@@BinGroup/addBinToSelectedBinInBinGroup':
  return {
    ...state,
    selectedBinInBinGroup: [...(state.selectedBinInBinGroup || []), action.bin]
  };

case '@@BinGroup/removeBinFromSelectedBinInBinGroup':
  return {
    ...state,
    selectedBinInBinGroup: state.selectedBinInBinGroup?.filter(bin => bin.bin_id !== action.bin_id) || null
  };


case '@@InitBinGroupListState/ClearNewBinGroupAction':
    return {
        ...state,
        newBinGroup: {
            group_name_tc: '',
            group_name_en: '',
            is_active: 1
        },
    };

        default:
            return state;
    }

}
